<template>
  <el-table :data="data" class="table__articles w-100" :default-sort="{ prop: 'title', order: 'ascending' }">
    <el-table-column :label="$t('Title')" prop="title" min-width="160" sortable></el-table-column>

    <el-table-column :label="$t('Publish date')" prop="publish_date" sortable>
      <template slot-scope="props">
        <span>{{ $d(new Date(props.row.publish_date), 'short') }}</span>
      </template>
    </el-table-column>

    <el-table-column :label="$t('Tags')" prop="tags">
      <template slot-scope="props">
        <ul class="list list--horizontal">
          <li v-for="(tag, index) in props.row.tags" :key="index">
            <el-tag type="primary">{{ tag.tag.title }}</el-tag>
          </li>
        </ul>
      </template>
    </el-table-column>

    <!-- Actions -->
    <el-table-column :label="$t('Actions')" align="right">
      <template slot-scope="props">
        <el-button-group>
          <el-button type="default" @click="onClickOpen(props.row)" :title="$t('Open article')">{{ $t('Open') }}</el-button>
          <el-button
            v-if="!isManuallyPublished(props.row)"
            type="success"
            :disabled="autoPublication"
            :title="$t('Publish article')"
            @click="$emit('publish', props.row)"
            >{{ $t('Publish') }}</el-button
          >
          <el-button
            v-else
            type="warning"
            :disabled="autoPublication"
            :title="$t('Unpublish article')"
            @click="$emit('unpublish', props.row)"
            >{{ $t('Unpublish') }}</el-button
          >
        </el-button-group>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'BB_TableArticles',

  props: {
    data: {
      type: Array,
      required: true
    },

    autoPublication: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data() {
    return {
      isLoading: false
    };
  },

  methods: {
    isManuallyPublished(item) {
      return item.isManuallyPublished;
    },

    onClickOpen(item) {
      this.$store.commit('dialog/OPEN', {
        title: item.title,
        content: `${item.teaser} ${item.body}`
      });
    }
  }
};
</script>

<style lang="scss">
.table__articles {
  .el-table_1_column_1 {
    @media screen and (max-width: $screen-md) {
      width: 50px;
    }
  }

  .el-table_1_column_2 {
    @media screen and (max-width: $screen-md) {
      width: 100%;
    }
  }

  [name*='el-table_1_column_'],
  [class*='el-table_1_column_'] {
    &:not(.el-table_1_column_1):not(.el-table_1_column_2) {
      @media screen and (max-width: $screen-md) {
        display: none;
      }
    }
  }

  .el-table__header,
  .el-table__body {
    @media screen and (max-width: $screen-md) {
      max-width: 100%;
    }
  }
}
</style>
